import {handleDatabaseError} from "../utils";
import type {DbClient} from "./activity-types";

export interface ResolvedCustomerCompany {
  companyId: string;
  companyName: string;
}

/**
 * 顧客 ID 配列から「代表名刺の会社」を一括解決する。
 *
 * - viewerHostessId を渡すとホステス視点 (自分の名刺集合内の代表)
 * - 渡さないと admin 視点 (全名刺中の代表)
 * - 解決できなかった customer_id は Map に入らない (= 呼び出し側は空欄表示)
 *
 * 仕様: docs/domain/20260527-customer-company-context-display.md
 */
export async function resolveCustomerCompanies(
  client: DbClient,
  customerIds: string[],
  viewerHostessId?: string | null,
): Promise<Map<string, ResolvedCustomerCompany>> {
  const unique = Array.from(new Set(customerIds.filter(Boolean)));
  if (unique.length === 0) return new Map();

  const {data, error} = await client.rpc("resolve_customer_companies", {
    p_customer_ids: unique,
    p_viewer_hostess_id: viewerHostessId ?? undefined,
  });

  if (error) handleDatabaseError(error);

  const map = new Map<string, ResolvedCustomerCompany>();
  for (const row of data ?? []) {
    if (row.customer_id && row.company_id && row.company_name) {
      map.set(row.customer_id, {
        companyId: row.company_id,
        companyName: row.company_name,
      });
    }
  }
  return map;
}
